import { ColDef, ColGroupDef, ValueGetterParams } from 'ag-grid-community'
import { intl } from '../../../../i18n'
import { ColumnType } from '../../../containers/commons/AgGrid'
import {
  SprintReportMemberAlias,
  getSprintReportKeyLabel,
} from '../../../../lib/functions/sprintReport'
import { getWbsItemStatusLabel } from '../../../../lib/functions/wbsItem'
import { WbsItemStatus } from '../../../../domain/entity/WbsItemEntity'
import { SprintReportRow } from '../model/sprintReportRow'
import { SprintReportWbsItemStatusCellRenderer } from '../components/cellRenderer/SprintReportWbsItemStatusCellRenderer'

const isWbsItemStatusKey = (key: string): key is WbsItemStatus =>
  (Object.values(WbsItemStatus) as string[]).includes(key)

export const defaultColumns: (ColDef | ColGroupDef)[] = [
  {
    field: 'rowNumber',
    type: [ColumnType.sequenceNo],
    pinned: 'left',
    lockPosition: 'left',
  },
  {
    headerName: intl.formatMessage({
      id: 'sprintReport.columnGroup.basicInformation.name',
    }),
    children: [
      {
        field: 'member.name',
        headerName: intl.formatMessage({
          id: 'sprintReport.column.responsible.name',
        }),
        pinned: 'left',
        lockPosition: 'left',
        width: 120,
        floatingFilter: true,
        filter: 'agSetColumnFilter',
        valueGetter: (params: ValueGetterParams<SprintReportRow>) => {
          if (!params.data?.member) return ''
          switch (params.data.member.name) {
            case SprintReportMemberAlias.TOTAL:
              return intl.formatMessage({ id: 'sprintReport.alias.total' })
            case SprintReportMemberAlias.UNASSIGNED:
              return intl.formatMessage({
                id: 'sprintReport.alias.unassigned',
              })
            default:
              return params.data.member.name
          }
        },
        cellStyle: params => {
          // 直前の行と同じメンバーなら名前を非表示にして連続行を視覚的にグルーピングする
          if (!params.node || params.node.rowIndex == null) {
            return { color: 'inherit' }
          }
          const prev = params.api.getDisplayedRowAtIndex(
            params.node.rowIndex - 1
          )
          const sameMember =
            !!prev?.data?.member?.uuid &&
            prev.data.member.uuid === params.data?.member?.uuid
          return { color: sameMember ? 'transparent' : 'inherit' }
        },
      },
      {
        field: 'key',
        headerName: intl.formatMessage({
          id: 'sprintReport.column.wbsItemStatus.name',
        }),
        pinned: 'left',
        lockPosition: 'left',
        width: 120,
        floatingFilter: true,
        filter: 'agSetColumnFilter',
        cellRenderer: SprintReportWbsItemStatusCellRenderer,
        valueGetter: (params: ValueGetterParams<SprintReportRow>) => {
          if (!params.data) return ''
          const key = params.data.key
          if (isWbsItemStatusKey(key)) {
            return getWbsItemStatusLabel(key)
          }
          return getSprintReportKeyLabel(key)
        },
      },
    ],
  },
]
